import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  DefaultLanguage, getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import {
  NewsCategoryStore,
} from '../../mobx-store/stores/newsCategoryStore';
import classes from './addEditNewsCategory.module.scss';

interface IProps extends WithSnackbarProps {
  newsCategoryStore: NewsCategoryStore;
  countryStore: CountryStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  processing: boolean;
  isEgypt: boolean;
  loadingManagedCountries: boolean;
  selectedLang: string;
}

@inject('newsCategoryStore')
@inject('countryStore')
@observer
export class AddEditNewsCategory extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  categoryId = -1;

  pageTitle = '';

  categoryFormTitle = '';

  categorySchema: any;

  submitButton: any;

  cancelButton: any;

  lastHistory = -1;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps,
    isConstructor = true, isReceiveProps = false) {
    if (props.match.params.id) {
      this.isNew = false;
      this.categoryId = props.match.params.id;
      this.pageTitle = translate('editNewsCategoryPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addNewsCategoryPageTitle', {
      });
    }
    this.initCategorySchema();
    this.initState(isConstructor, isReceiveProps);
    this.categoryFormTitle = translate('newsCategoryFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false, true);
      this.forceUpdate();
      this.setState({
        loadingManagedCountries: false,

      });
      if (!this.isNew) {
        this.getCategory(languageCodes.english);
      }
    }
  }

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getCategory(langCode);
      }
    }
  };

  initCategorySchema = () => {
    this.categorySchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      imageUrl: Yup.array(),
    });
  };

  initState = (isConstructor = true, isReceiveProps = false) => {
    const initState: IState = {
      selectedLang: languageCodes.english,
      processing: false,
      loadingManagedCountries: true,
      loading: !this.isNew,
      isEgypt: isReceiveProps ? this.state.isEgypt : false,
      formFields: [
        {
          name: 'title',
          label: translate('editNewsCategoryTitleEn', {
          }),
          type: 'text',
          filedType: 'InputField',
        },
        {
          name: 'imageUrl',
          label: translate('addFacilityCategoryImage', {
          }),
          filedType: 'GalleryField',
          isLimitToOneImage: true,
          accept: 'image/*',
          size: 200,
        },
      ],
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = (values: any): void => {
    values.availableCountries = this.props.countryStore.managedCountries.map((country: ICountry) => country.isoCode);
    this.setState({
      processing: true,
    });
    if (this.isNew) {
      try {
        this.props.newsCategoryStore.createArticleCategory(this.props.countryStore.managedCountries, values, this.state.selectedLang)
          .then((categoryId) => {
            SnackBarComponent.getInstance().openSnackbar(translate('createdMessage', {
            }), 5000, 'success');
            if (this.state.isEgypt) {
              this.props.history.push(`${categoryId}/edit`);
            } else {
              this.props.history.go(this.lastHistory);
            }
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 5000, 'error');
      }
    } else {
      console.log(this.categoryId);
      this.props.newsCategoryStore.updateArticleCategory(values, this.categoryId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handleCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.state.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  updateStateWithCategoryData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: (this.props.newsCategoryStore.selectedCategory as any)[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  render() {
    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <IconButton
            className={classes.backButton}
            onClick={() => this.props.history.goBack()}
            aria-label="Back"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <Typography className={classes.title} variant="h6" gutterBottom>
            {this.pageTitle}
          </Typography>
        </div>
        <div className={classes.content}>
          {this.state.loading || this.state.loadingManagedCountries
            ? <Spinner />
            : (
              <GeneralFormComponent
                dropdownLanguages={this.state.isEgypt ? this.dropdownLanguages : null}
                formTitle={this.categoryFormTitle}
                fields={this.state.formFields}
                formSchema={this.categorySchema}
                submitButton={this.getSubmitButton()}
                cancelButton={this.getCancelButton()}
                processing={this.state.processing}
              />
            )}
        </div>
      </div>
    );
  }

  async componentDidMount() {
    await this.props.countryStore.getUserManagedCountries();
    this.setState({
      loadingManagedCountries: false,
    });
    if (this.props.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.setState({
        isEgypt: true,
        selectedLang: DefaultLanguage,
      });
    }

    if (!this.isNew) {
      this.getCategory(this.state.selectedLang);
    }
  }

  getCategory = (langCode: string) => {
    this.setState({
      loading: true,
    });
    console.log(this.categoryId);
    this.props.newsCategoryStore.getArticleCategoryById(this.categoryId, langCode)
      .then(() => {
        this.updateStateWithCategoryData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default withRouter(AddEditNewsCategory);
